const Auth = {
  accountLogin: {
    url: "/login",
    method: "POST",
  },
  accountSignUp: {
    url: "/signup",
    method: "POST",
  },
  updateProfile: (id) => ({
    url: `/user/${id}`,
    method: "PUT",
  }),
  accountLogout: {
    url: "/logout",
    method: "POST",
  },
  updatePhoneNumber: {
    url: "/user/change-phone-number",
    method: "POST",
  },
  verifyOtp: {
    url: "/user/verify-phone-number",
    method: "POST",
  },
  userForgotPassword: {
    url: "/forgot-password",
    method: "PATCH",
  },
  userChangePassword: {
    url: "/change-password",
    method: "PATCH",
  },
  userResetPassword: {
    url: "/reset-password",
    method: "PATCH",
  },
  userOtpVerification: {
    url: "/verify-otp",
    method: "POST",
  },
  userDeleteOtpVerification: {
    url: "/delete-verify-otp",
    method: "POST",
  },
  userVerifyAccount: {
    url: "/verify-email",
    method: "POST",
  },
  userDeleteAccountRequest: {
    url: "/delete-account",
    method: "DELETE",
  },
};
export default Auth;
